import {
  Carousel,
  CarouselIndicator,
  CarouselIndicatorVideoIcon,
  CarouselMainContainer,
  CarouselNext,
  CarouselPrevious,
  CarouselThumbsContainer,
  SliderMainItem,
  SliderThumbItem,
} from "@/components/ui/carousel-pro-old"
import VideoPlayer from "@/components/VideoPlayer/videoPlayer"
import clsx from "clsx"
import Image from "next/image"
import { placeHolderImage } from "@/constants/placeHolderImage"

export const ProductCarousel = ({
  images,
  videoUrl,
  seoColorLabel,
  name,
}: {
  images: any[]
  videoUrl?: string
  seoColorLabel: string
  name: string
}) => {
  // Create a modified array that includes the video if it exists
  const carouselItems = videoUrl
    ? [
        images[0],
        {
          isVideo: true,
          firstImage: images[0],
        },
        ...images.slice(1),
      ]
    : images

  return (
    <Carousel className={clsx("gap-0 pt-[5px] lg_pt-0")}>
      <CarouselNext className="shadow-md top-1/2 hidden h-10 w-10 -translate-y-1/2 rounded border-none bg-white lg_top-[40%] lg_flex" />
      <CarouselPrevious className="shadow-md top-1/2 hidden h-10  w-10 -translate-y-1/2 rounded border-none bg-white  lg_top-[40%] lg_flex" />
      <CarouselMainContainer>
        {carouselItems.map((item, index) => {
          if (item.isVideo) {
            return (
              <SliderMainItem key={`video-${index}`} className="bg-transparent">
                <div className="outline-border size-full bg-background flex h-full w-full items-center justify-center outline-none">
                  <div className="relative h-full w-full">
                    <VideoPlayer
                      controls={true}
                      loop={true}
                      url={videoUrl}
                      width={"100%"}
                      height={"100%"}
                      config={{
                        youtube: {
                          playerVars: {
                            playsinline: 1,
                          },
                        },
                        file: {
                          attributes: {
                            controlsList: "nodownload",
                            disablePictureInPicture: true,
                          },
                        },
                      }}
                    />
                    <div
                      className="z-99 pointer-events-none absolute inset-0 "
                      style={{
                        background: "transparent",
                      }}
                    >
                      <div
                        className="pointer-events-auto absolute inset-x-0 bottom-[56px] h-[calc(100%-106px)]"
                        onTouchStart={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                      />
                    </div>
                  </div>
                </div>
              </SliderMainItem>
            )
          }

          const image = item.isVideo ? item.firstImage : item
          const alt = `${seoColorLabel} ${name} ${index + 1}`

          return (
            <SliderMainItem
              key={`image-${index}`}
              className="bg-transparent p-0"
            >
              <div className="outline-border size-full bg-background flex items-center justify-center outline-none">
                <Image
                  src={image?.url}
                  alt={alt}
                  title={alt}
                  width={860}
                  height={860}
                  quality={100}
                  placeholder={placeHolderImage}
                />
              </div>
            </SliderMainItem>
          )
        })}
      </CarouselMainContainer>
      <CarouselThumbsContainer className="mx-auto mt-1 flex min-h-[15px] w-max items-center justify-center gap-x-1 rounded-[50px] bg-[#efefef] px-2.5 lg_hidden">
        {carouselItems.map((item, index) => {
          if (item.isVideo) {
            return <CarouselIndicatorVideoIcon index={index} />
          }

          return <CarouselIndicator key={`indicator-${index}`} index={index} />
        })}
      </CarouselThumbsContainer>
      <CarouselThumbsContainer className="hidden lg_flex">
        {carouselItems.map((item, index) => {
          const image = item.isVideo ? item.firstImage : item
          const alt = `${seoColorLabel} ${name} ${index + 1}`

          return (
            <SliderThumbItem
              key={`thumb-${index}`}
              index={index}
              className="h-full w-full bg-transparent"
            >
              <div
                className="outline-border size-full bg-background flex items-center justify-center
            outline-none"
              >
                <Image
                  src={image?.url}
                  width={118}
                  height={118}
                  quality={100}
                  alt={alt}
                  title={alt}
                  className="h-full w-full object-cover"
                />
                {item.isVideo && (
                  <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center bg-[rgba(255,255,255,.4)]">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="25"
                        cy="25"
                        r="24"
                        stroke="white"
                        stroke-width="2"
                      />
                      <path
                        d="M33.75 23.701C34.75 24.2783 34.75 25.7217 33.75 26.299L21.75 33.2272C20.75 33.8046 19.5 33.0829 19.5 31.9282L19.5 18.0718C19.5 16.9171 20.75 16.1954 21.75 16.7728L33.75 23.701Z"
                        fill="white"
                        stroke="white"
                      />
                    </svg>
                  </div>
                )}
              </div>
            </SliderThumbItem>
          )
        })}
      </CarouselThumbsContainer>
    </Carousel>
  )
}
